import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "./../components/Header";
import Message from "./../components/LoadingError/Error";
import Loading from "./../components/LoadingError/Loading";
import { checkUserName, refDefault, setpass } from "../service";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";

const Register = ({ location, history }) => {
    window.scrollTo(0, 0);
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [passwordConfirm, setPasswordConfirm] = useState("");
    const { email, token, ref } = useParams();

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const redirect = location.search ? location.search.split("=")[1] : "/";

    const submitHandler = async (e) => {
        e.preventDefault();

        if (!username) {
            setError("Vui lòng nhập tên người dùng");
            return;
        }
        if (!password) {
            setError("Vui lòng nhập mật khẩu");
            return;
        }
        if (!passwordConfirm) {
            setError("Vui lòng nhập xác nhận mật khẩu");
            return;
        }
        if (passwordConfirm !== password) {
            setError("Mật khẩu xác nhận không khớp");
            return;
        }

        setLoading(true);
        const res = await checkUserName(username);

        if (res?.code === 200) {
            const setpas = await setpass(
                email,
                username,
                password,
                token,
                typeof ref !== "undefined" && ref !== "undefined" ? ref : refDefault
            );

            if (setpas?.code === 200) {
                history.push("/login");
            } else {
                setError(setpas?.message || "Đăng ký thất bại");
            }
        } else {
            setError(res?.message || "Tên người dùng đã tồn tại");
        }
        setLoading(false);
    };

    return (
        <>
            <Header />
            <div className="container d-flex flex-column justify-content-center align-items-center login-center">
                {error && <Message variant="alert-info">{error}</Message>}
                {loading && <Loading />}
                <form
                    className="Login col-md-8 col-lg-4 col-11"
                    onSubmit={submitHandler}
                >
                    <input
                        type="text"
                        placeholder="Tên người dùng"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                    />
                    <input
                        type="password"
                        placeholder="Mật khẩu"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                    <input
                        type="password"
                        placeholder="Xác nhận mật khẩu"
                        value={passwordConfirm}
                        onChange={(e) => setPasswordConfirm(e.target.value)}
                    />
                    <button type="submit">Đăng ký</button>
                    <p className="mt-3">
                        <Link to={redirect ? `/login?redirect=${redirect}` : "/login"}>
                            Đã có tài khoản? <strong>Đăng nhập</strong>
                        </Link>
                    </p>
                </form>
            </div>
        </>
    );
};

export default Register;
